export enum Role {
  anonymous = 'ANONYMOUS',
  identified = 'IDENTIFIED',
  subscriber = 'SUBSCRIBER',
  qrHost = 'QRHOST'
}
